import React from 'react'

import { Box } from '../Grid'

const Line = ({
  backgroundColor = 'light-dark(var(--brand-grey-50), var(--brand-grey-600))',
  borderRadius = '3px',
  height = '24px',
  width = '300px',
  maxWidth = '100%',
  ...props
}) => (
  <Box
    backgroundColor={backgroundColor}
    borderRadius={borderRadius}
    height={height}
    width={width}
    maxWidth={maxWidth}
    {...props}
  ></Box>
)

export default Line
